import { defineModule } from '@berky/module-contract'

/**
 * Das Manifest ist die einzige Verbindung zwischen Modul und Shell.
 * Die Shell findet diese Datei selbst — sie muss nirgends eingetragen werden.
 */
export default defineModule({
  id: 'liquiditaet',
  title: 'Liquidität',
  description: 'Liquidität planen und Zahlungsströme übersichtlich steuern.',
  icon: 'Wallet',
  order: 60,
  apiBasePath: '/api/liquiditaet',

  // Kein scopes-Feld: die Anmeldung an der API macht die Plattform. Sie kennt
  // den Bereich der Umgebung, in der sie gerade läuft — useApiClient() hängt
  // das passende Token von selbst an.

  // Beide Rollen schalten das vorgemerkte Modul frei. Die fachlichen
  // Unterschiede werden mit den späteren Funktionen umgesetzt.
  roles: ['liquiditaet.nutzer', 'liquiditaet.admin'],

  routes: () => import('./src/routes'),

  // Optional: eine Kennzahl für die Kachel auf der Startseite.
  // homeWidget: () => import('./src/home-widget'),
})
